module.exports = __webpack_public_path__ + "img/conference.2779da49.png";